export function PageLayout({
  title,
  children,
}: {
  title?: string;
  children: React.ReactNode;
}) {
  return (
    <div className="mx-auto w-full max-w-2xl px-4 py-4">
      {title && (
        <h2 className="mb-4 text-2xl font-bold text-foreground">{title}</h2>
      )}
      {children}
    </div>
  );
}
